/**
 * @returns {Object}
 */
export function notLessThan() {
    
    return {
        require: 'ngModel',
        link: (scope, element, attr, ctrl) => {
            
            const validate = (value) => {
                
                const comparisonModel = attr.notLessThan;
                
                if (!value || !comparisonModel) {
                    
                    ctrl.$setValidity('notLessThan', true);
                    
                } else {
                    
                    ctrl.$setValidity('notLessThan', parseFloat(value) >= parseFloat(comparisonModel));
                }
                
                return value;
            };
            
            ctrl.$parsers.unshift(validate);
            ctrl.$formatters.push(validate);
            
            attr.$observe('notLessThan', (comparisonModel) => {
                
                return validate(ctrl.$viewValue);
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/not-less-than.directive.js